import cx from 'classnames';
import * as React from 'react';
import Button, { Props as ButtonProps } from 'components/Button';
import Icon from 'components/Icon';

export type Props = ButtonProps;

export default function AddFamilyMemberButton({ className, ...props }: Props) {
  return (
    <Button
      {...props}
      aria-label="Add Family Member"
      level="primary"
      color="mascot"
      className={cx('AddFamilyMemberButton', className)}
      onClick={props.onClick}
    >
      <Icon name="person_plus" />
    </Button>
  );
}
